<template>
  <div>
  	 <EditDeviceLine ref="AddDeveceList"  :buttonType="'edit'" :data="singleDevice" :stationId="stationId" :timezone="timezone"></EditDeviceLine>
    <WindowForAlert :id="'alert'" :title="getLanguageStr('phrase713','当前电站没有合适的网关/采集器')" :btnCancel="false" ref="windowForAlert">
      <div>
        {{getLanguageStr('phrase714','只有子设备添加方式为"手动选择子设备"才能再次添加子设备。')}}
        <Help :code="'noSystem'" :btnClose="false" class="vaM ml1x"></Help>
      </div>
      <button slot="btmBtn" class="functionBtn close" type="button">{{$t('cmd15',['我知道了'])}}</button>
    </WindowForAlert>
    <Window :id="'newConnectsDevices'" :title="getLanguageStr('word1753','添加新子设备')" ref="Window">
      <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
          <button class="functionBtn close">{{$t('cmd24',['完成'])}}</button>
      </div>
      <div fillHeight="window,-#newConnectsDevices .head" scroll>
          <div class="w60pct mc mt2x mb1x pb4x">
            <div class="mb2x">{{getLanguageStr('phrase835','以下为当前电站子设备添加方式为“手动选择子设备”的网关/采集器列表，请点击网关/采集器重新选择子设备')}}</div>
            <div v-for="(item,index) in snList" :key="index" class="tableSys">
					      <div class="clearfix pt05x pb05x lh15 vaM_E">
					          <div class="dpIB dpIB_E">
					              <span class="w20x-min">{{item.sn}}</span>
					              <div>
					                  <MyRadio class="dpIB" :name="'intent'+index" v-model="item.autoDiscovery" :label="false">{{getLanguageStr("word1620","手动添加子设备")}}</MyRadio>
					              </div>
					          </div>
					          <button :title="$t('cmd108',['点击展开/收起'])" type="button" class="fR fa fa-angle-double-right hover-c-main fs16x mr05x cSub tra" @click="operateModeChange(item)"></button>
					      </div>
            </div>
            
          </div>
      </div>
    </Window>
  </div>

</template>

<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import Window from '@/components/common/ui/WindowForNew.vue'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import Select from '@/components/common/ui/Select.vue'
import Help from '@/components/common/Help.vue'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import InputText from '@/components/common/ui/InputText.vue'
import EditDeviceLine from '@/components/common/AddDevice/EditDeviceLine.vue'
import {GetGateway, apiAddDevice} from '@/api/maintain/plant/list.js'
import MyRadio from '@/components/common/ui/Radio'
export default {
  name: 'AddConnectsDevices',
  components: {Window, Select, InputText, EditDeviceLine, NoResult, Loading, WindowForAlert, Help,MyRadio},
  props:{
    timezone:{
      type:String,
    }
  },
  data () {
    return {
      stationId: '',
      snList: [],
      singleDevice:{}
    }
  },
  methods: {
    getLanguageStr,
     operateModeChange (data) {
     	this.singleDevice=data;
     	 this.$nextTick(() => {
      this.$refs.AddDeveceList.show()
      });
    },
    show (data) {
      this.stationId = data.stationId
      this._GetDevice()
    },
    _GetDevice () {
      this.snList = []
      GetGateway(this.stationId).then(res => {
        if (res.length > 0) {
          let result=res.filter(el=>!el.autoDiscovery)
          if(result.length){
            this.$refs.Window.show()
            this.snList = result.map(el => ({
              // deviceType: el.type,
              autoDiscovery: false,
              sn: el.sn,
              subDeviceIds: [],
              // sensorCode: el.sensorCode
            }))
          }else{
            this.$refs.windowForAlert.show()
          }
        } else {
          this.$refs.windowForAlert.show()
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    save () {
      let newArr = []
      if (this.snList.length) {
        this.snList.forEach((val, index) => {
          newArr.push(...this.snList[index].subDeviceIds)
        })
        apiAddDevice(this.stationId, newArr).then(res => {
          this.$refs.Window.hide()
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      } else {
        this.$refs.Window.hide()
      }
    }
  },
  mounted () {
    lib.fillHeight()
    lib.setScroll($('#newConnectsDevices [scroll]'))
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/EditConnectsDevices.vue